import { createContext } from '@chakra-ui/react-utils';

import { PreferredUnitSystem } from '@frontend/api';

import { Measure } from 'constants/unitOfMeasure';

export type MathInputContextValue = {
  preferredUnitSystem: PreferredUnitSystem;
  measure: Measure;
  hasUnits: boolean;
};

export const [MathInputProvider, useMathInputProvider] =
  createContext<MathInputContextValue>({
    name: 'MathInputContext',
    strict: true,
    errorMessage:
      'useMathInputContext: `context` is undefined. Seems you forgot to wrap all menu components within `<MathInput />`',
  });
